import React from 'react';
import { Box } from '@material-ui/core';

import CarsProvider from './context/CarsProvider';
import TopBar from './components/TopBar';
import CarList from './components/CarList';

const Cars = () => {
	return (
		<CarsProvider>
			<Box>
				<TopBar />
				<Box p={3}>
					<CarList />
				</Box>
			</Box>
		</CarsProvider>
	);
};

export default Cars;
